<template>
  <TwoColumn>
    <template #left>
      <h1 v-t="'pages.401.error_code'" class="mb-5 text-primary"></h1>
      <h2 v-t="'pages.401.error_text'" class="mb-2"></h2>
      <p v-t="'pages.401.message'" class="mb-10 text-base leading-relaxed text-neutral-700"></p>
      <div>
        <VcButton to="/sign-in" class="w-40">
          {{ $t("pages.401.login_button") }}
        </VcButton>
      </div>
    </template>
  </TwoColumn>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { usePageHead } from "@/core/composables";
import { TwoColumn } from "@/shared/layout";

const { t } = useI18n();

usePageHead({
  title: `${t("pages.401.error_code")} ${t("pages.401.error_text")}`,
});
</script>
